import { motion } from 'framer-motion'
import { Container } from '@/components/layout/Container'
import { useSettings } from '@/hooks/useSettings'
import { unsplash, imageIds } from '@/lib/images'

export function About() {
  const { about } = useSettings()
  const eyebrow = about?.eyebrow ?? 'The House'
  const title = about?.title ?? 'little sky'
  const paragraphs = about?.paragraphs?.length ? about.paragraphs : [
    'little sky was founded on a simple belief: buying fragrance should feel like discovery, not guesswork. We make fine, modern perfumes and help people find the ones that fit their skin, their mood, and their life.',
    'Our formulas are composed in small batches with a focus on clarity. Each fragrance is built around a clear idea — a place, a memory, a temperature — so the scent story is easy to understand and easy to wear.',
    'We ship samples with every order, credit sample costs toward full bottles, and offer refills for our larger sizes. The goal is less waste, more joy, and a wardrobe of scents you actually use.',
  ]
  const imageUrl = about?.imageUrl || unsplash(imageIds.lifestyle2, 800, 1000)
  const cards = about?.cards?.length ? about.cards : [
    { title: 'Cruelty-Free', body: 'No animal testing at any stage of formulation or production.' },
    { title: 'Refillable', body: '50ml and 100ml sizes are designed to be refilled, reducing glass waste.' },
    { title: 'Sample First', body: 'We encourage sampling before committing. Every sample credit applies to a full bottle.' },
  ]

  return (
    <div className="pt-28 pb-24">
      <Container className="max-w-4xl">
        <p className="mb-4 text-xs uppercase tracking-[0.2em] text-wd-orange">{eyebrow}</p>
        <h1 className="mb-8 font-display text-4xl normal-case text-carbon md:text-6xl">
          {title.toLowerCase()}
        </h1>

        <div className="grid gap-12 lg:grid-cols-2">
          <div className="space-y-6 leading-relaxed text-carbon/60">
            {paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <img
              src={imageUrl}
              alt={`${title} atelier`}
              className="aspect-[4/5] w-full object-cover"
            />
          </motion.div>
        </div>

        <div className="mt-24 border-t border-ink/10 pt-16">
          <h2 className="mb-8 font-display text-2xl normal-case text-carbon">
            Our pledge
          </h2>
          <ul className="grid gap-6 text-carbon/60 md:grid-cols-3">
            {cards.map((card) => (
              <li key={card.title} className="bg-wd-mist p-6">
                <h3 className="mb-2 font-display text-lg normal-case text-carbon">{card.title}</h3>
                <p className="text-sm">{card.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </div>
  )
}
